//classes
import { CommManager } from "./Manager/CommManager.js";
import { CommBase } from "./Comm/Comm.js";
import { TasksManager } from "./Tasks/TaskManager.js";
import { DataSyncManager } from "./Data/DataSyncManager.js";
import { InternalTasks } from "./Internal/InternalTasks.js";
export const ThreadComm = {
    threadNumber: 0,
    threadName: "unamed-threadcomm-thread",
    environment: "browser",
    _comms: {},
    _commManageras: {},
    _queues: new Map(),
    parent: new CommBase(""),
    internal: InternalTasks,
    __initalized: false,
    __expectedPorts: {},
    crypto: {},
    async $INIT(threadName, threadParentName) {
        this.threadName = threadName;
        this.parent.name = threadParentName;
        const port = await this.getWorkerPort();
        this.parent.setPort(port);
        this.__initalized = true;
        this.addComm(this.parent);
        if (this.environment == "browser") {
            this.crypto = crypto;
        }
        if (this.environment == "node") {
            //@ts-ignore
            this.crypto = require("crypto");
        }
    },
    getSyncedQueue(threadId, queueId) {
        if (!this._queues.has(threadId))
            return;
        return this._queues.get(threadId)?.get(queueId);
    },
    addComm(comm) {
        this._comms[comm.name] = comm;
    },
    createComm(name, mergeObject = {}) {
        const newCom = Object.assign(new CommBase(name), mergeObject);
        this._comms[name] = newCom;
        return newCom;
    },
    createCommManager(data) {
        const newCommManager = new CommManager(data);
        this._commManageras[data.name] = newCommManager;
        return newCommManager;
    },
    getComm(id) {
        return this._comms[id];
    },
    getCommManager(id) {
        return this._commManageras[id];
    },
    async getWorkerPort() {
        if (this.environment == "browser") {
            return self;
        }
        if (this.environment == "node") {
            //@ts-ignore
            const { parentPort } = require("worker_threads");
            return parentPort;
        }
    },
    registerTasks(id, run, mode = "async") {
        TasksManager.registerTasks(id, run, mode);
    },
    onDataSync(dataType, onSync, onUnSync) {
        return DataSyncManager.registerDataSync(dataType, onSync, onUnSync);
    },
};
if (
//@ts-ignore
typeof process !== "undefined" &&
    typeof Worker === "undefined" &&
    typeof window === "undefined") {
    ThreadComm.environment = "node";
}
